module.exports = __webpack_public_path__ + "static/media/success.e2b9525a.svg";